import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosApiInstance from "../../utils/apiClient";
import { endpoints } from "../config";
import { messageFrontEnd } from "../../utils/mensajeErrorCliente";

const initialState = {
    periodoActivo: {},
    capacitaciones: [],
    tiposCapacitaciones: [],
    estudiosGrados: [],
    periodoEmpleadoArea: [],
    periodos: []
}

// * LIMPIAR SUCCESS
export const fetchCambiarSuccess = createAsyncThunk("capacitaciones/fetchCambiarSuccess",
    async () => {
      return null;
    }
);  

export const fetchCapacitacionesPeriodoActual = createAsyncThunk("capacitaciones/fetchCapacitacionesPeriodoActual",
    async () => {
        var resultado = await axiosApiInstance.get(endpoints.capacitaciones.getList);
        return resultado.data;
    }
);  

export const fetchTiposCapacitaciones = createAsyncThunk("capacitaciones/fetchTiposCapacitaciones",
    async () => {
        var resultado = await axiosApiInstance.get(endpoints.capacitaciones.tipos);
        return resultado.data;
    }
);  

export const fetchEstudiosGrados = createAsyncThunk("capacitaciones/fetchEstudiosGrados",
    async () => {
        var resultado = await axiosApiInstance.get(endpoints.capacitaciones.estudiosGrados);
        return resultado.data;
    }
);  

export const fetchPeriodoActivo = createAsyncThunk("capacitaciones/fetchPeriodoActivo",
    async () => {
        var resultado = await axiosApiInstance.get(endpoints.capacitaciones.periodoActivo);
        return resultado.data;
    }
);  

export const fetchEmpleadosInsert = createAsyncThunk("capacitaciones/fetchEmpleadosInsert",
    async (data) => {
        var resultado = await axiosApiInstance.post(endpoints.capacitaciones.insertEmpleados, data);
        return resultado.data;
    }
);  

export const fetchEmpleadosUpdate = createAsyncThunk("capacitaciones/fetchEmpleadosUpdate",
    async (data) => {
        var resultado = await axiosApiInstance.post(endpoints.capacitaciones.updateEmpleado, data);
        return resultado.data;
    }
);  

export const fetchEmpleadosDelete = createAsyncThunk("capacitaciones/fetchEmpleadosDelete",
    async (id) => {
        var resultado = await axiosApiInstance.post(`${endpoints.capacitaciones.deleteEmpleado}?empleadoCapacitacionId=${id}`);
        return resultado.data;
    }
);  

export const fetchPeriodoEmpleadosArea = createAsyncThunk("capacitaciones/fetchPeriodoEmpleadosArea",
    async (filtro) => {
        var resultado = await axiosApiInstance.post(endpoints.capacitaciones.periodoEmpleadosArea, filtro);
        return resultado.data;
    }
);  

export const fetchPeriodos = createAsyncThunk("capacitaciones/fetchPeriodos",
    async () => {
        var resultado = await axiosApiInstance.get(endpoints.capacitaciones.periodos);
        return resultado.data;
    }
);  

export const fetchDeleteCapacitacionArea = createAsyncThunk("capacitaciones/fetchDeleteCapacitacionArea",
    async (data) => {
        var resultado = await axiosApiInstance.post(endpoints.capacitaciones.deleteCapacitacionArea, data);
        return resultado.data;
    }
);  


export const CapacitacionesSlice = createSlice({
      name:"capacitaciones",
        initialState,
        reducers:{},
        extraReducers(builder){
            builder
            .addCase(fetchCambiarSuccess.fulfilled, (state) => {
                state.isSuccess = "idle";
                state.message = '';
            })
            .addCase(fetchCapacitacionesPeriodoActual.pending, (state) => {
                state.isSuccess = "idle"
                state.isLoading = true;
            })
            .addCase(fetchCapacitacionesPeriodoActual.fulfilled, (state, action) => {

                if (action.payload.isSuccess) {
                    state.isSuccess = 'success'; 
                    state.capacitaciones = action.payload.data ?? [];
                } 
                else {
                    state.isSuccess = 'error'; 
                    state.message = action.payload.message;
                }

                state.isLoading = false;
            })
            .addCase(fetchCapacitacionesPeriodoActual.rejected, (state, action) => {
                state.isLoading = false;
                state.isSuccess = 'error'; 
                state.capacitaciones = [];
                state.message = messageFrontEnd();
                console.error(action.error.message);
            })
            .addCase(fetchTiposCapacitaciones.pending, (state) => {
                state.isSuccess = "idle"
                state.isLoading = true;
            })
            .addCase(fetchTiposCapacitaciones.fulfilled, (state, action) => {

                if (action.payload.isSuccess) {
                    state.isSuccess = 'success'; 
                    state.tiposCapacitaciones = action.payload.data ?? [];
                } 
                else {
                    state.isSuccess = 'error'; 
                    state.message = action.payload.message;
                }

                state.isLoading = false;
            })
            .addCase(fetchTiposCapacitaciones.rejected, (state, action) => {
                state.isLoading = false;
                state.isSuccess = 'error'; 
                state.tiposCapacitaciones = [];
                state.message = messageFrontEnd();
                console.error(action.error.message);
            })
            .addCase(fetchEstudiosGrados.pending, (state) => {
                state.isSuccess = "idle"
                state.isLoading = true;
            })
            .addCase(fetchEstudiosGrados.fulfilled, (state, action) => {

                if (action.payload.isSuccess) {
                    state.isSuccess = 'success'; 
                    state.estudiosGrados = action.payload.data ?? [];
                } 
                else {
                    state.isSuccess = 'error'; 
                    state.message = action.payload.message;
                }

                state.isLoading = false;
            })
            .addCase(fetchEstudiosGrados.rejected, (state, action) => {
                state.isLoading = false;
                state.isSuccess = 'error'; 
                state.estudiosGrados = [];
                state.message = messageFrontEnd();
                console.error(action.error.message);
            })
            .addCase(fetchPeriodoEmpleadosArea.pending, (state) => {
                state.isSuccess = "idle"
                state.isLoading = true;
            })
            .addCase(fetchPeriodoEmpleadosArea.fulfilled, (state, action) => {

                if (action.payload.isSuccess) {
                    state.isSuccess = 'success'; 
                    state.periodoEmpleadoArea = action.payload.data ?? [];
                } 
                else {
                    state.isSuccess = 'error'; 
                    state.message = action.payload.message;
                }

                state.isLoading = false;
            })
            .addCase(fetchPeriodoEmpleadosArea.rejected, (state, action) => {
                state.isLoading = false;
                state.isSuccess = 'error'; 
                state.periodoEmpleadoArea = [];
                state.message = messageFrontEnd();
                console.error(action.error.message);
            })
            .addCase(fetchPeriodos.pending, (state) => {
                state.isSuccess = "idle"
                state.isLoading = true;
            })
            .addCase(fetchPeriodos.fulfilled, (state, action) => {

                if (action.payload.isSuccess) {
                    state.isSuccess = 'success'; 
                    state.periodos = action.payload.data ?? [];
                } 
                else {
                    state.isSuccess = 'error'; 
                    state.message = action.payload.message;
                }

                state.isLoading = false;
            })
            .addCase(fetchPeriodos.rejected, (state, action) => {
                state.isLoading = false;
                state.isSuccess = 'error'; 
                state.periodos = [];
                state.message = messageFrontEnd();
                console.error(action.error.message);
            })
            .addCase(fetchPeriodoActivo.pending, (state) => {
                state.isSuccess = "idle"
                state.isLoading = true;
            })
            .addCase(fetchPeriodoActivo.fulfilled, (state, action) => {

                if (action.payload.isSuccess) {
                    state.isSuccess = 'success'; 
                    state.periodoActivo = action.payload.data ?? {};
                } 
                else {
                    state.isSuccess = 'error'; 
                    state.message = action.payload.message;
                }

                state.isLoading = false;
            })
            .addCase(fetchPeriodoActivo.rejected, (state, action) => {
                state.isLoading = false;
                state.isSuccess = 'error'; 
                state.periodoActivo = {};
                state.message = messageFrontEnd();
                console.error(action.error.message);
            })
            .addCase(fetchEmpleadosInsert.pending, (state) => {
                state.isSuccess = "idle"
                state.isLoading = true;
            })
            .addCase(fetchEmpleadosInsert.fulfilled, (state, action) => {

                if (action.payload.isSuccess) {
                    state.isSuccess = 'success'; 
                } 
                else {
                    state.isSuccess = 'error'; 
                }
                
                state.message = action.payload.message;
                state.isLoading = false;
            })
            .addCase(fetchEmpleadosInsert.rejected, (state, action) => {
                state.isLoading = false;
                state.isSuccess = 'error'; 
                state.message = messageFrontEnd();
                console.error(action.error.message);
            })
            .addCase(fetchEmpleadosUpdate.pending, (state) => {
                state.isSuccess = "idle"
                state.isLoading = true;
            })
            .addCase(fetchEmpleadosUpdate.fulfilled, (state, action) => {

                if (action.payload.isSuccess) {
                    state.isSuccess = 'success'; 
                } 
                else {
                    state.isSuccess = 'error'; 
                }
                
                state.message = action.payload.message;
                state.isLoading = false;
            })
            .addCase(fetchEmpleadosUpdate.rejected, (state, action) => {
                state.isLoading = false;
                state.isSuccess = 'error'; 
                state.message = messageFrontEnd();
                console.error(action.error.message);
            })
            .addCase(fetchEmpleadosDelete.pending, (state) => {
                state.isSuccess = "idle"
                state.isLoading = true;
            })
            .addCase(fetchEmpleadosDelete.fulfilled, (state, action) => {

                if (action.payload.isSuccess) {
                    state.isSuccess = 'success'; 
                } 
                else {
                    state.isSuccess = 'error'; 
                }
                
                state.message = action.payload.message;
                state.isLoading = false;
            })
            .addCase(fetchEmpleadosDelete.rejected, (state, action) => {
                state.isLoading = false;
                state.isSuccess = 'error'; 
                state.message = messageFrontEnd();
                console.error(action.error.message);
            })
            .addCase(fetchDeleteCapacitacionArea.pending, (state) => {
                state.isSuccess = "idle"
                state.isLoading = true;
            })
            .addCase(fetchDeleteCapacitacionArea.fulfilled, (state, action) => {

                if (action.payload.isSuccess) {
                    state.isSuccess = 'success'; 
                } 
                else {
                    state.isSuccess = 'error'; 
                }
                
                state.message = action.payload.message;
                state.isLoading = false;
            })
            .addCase(fetchDeleteCapacitacionArea.rejected, (state, action) => {
                state.isLoading = false;
                state.isSuccess = 'error'; 
                state.message = messageFrontEnd();
                console.error(action.error.message);
            })
        }
})

export const selectCapacitacionesPeriodoActivo = (state) => state.capacitaciones.capacitaciones;
export const selectTiposCapacitaciones = (state) => state.capacitaciones.tiposCapacitaciones;
export const selectEstudiosGrados = (state) => state.capacitaciones.estudiosGrados;
export const selectPeriodoActivo = (state) => state.capacitaciones.periodoActivo;
export const selectPeriodoEmpleadoArea = (state) => state.capacitaciones.periodoEmpleadoArea;
export const selectPeriodos = (state) => state.capacitaciones.periodos;
export const selectIsSuccess = (state) => state.capacitaciones.isSuccess;
export const selectIsLoading = (state) => state.capacitaciones.isLoading;
export const selectMessage = (state) => state.capacitaciones.message;

export const {} = CapacitacionesSlice.actions;
export default CapacitacionesSlice.reducer;